import { FC, useCallback, useState } from 'react'
import { isDetox } from '../../constants/platform'
import { useAppDispatch, useAppSelector } from '../../hooks/redux'
import { setIsArchive } from '../../redux/reducers/app'
import { setCurrentStation, stationSelectors } from '../../redux/reducers/station'
import { IStation } from '../../types/station'
import { performHaptics } from '../../utils/performHaptics'
import Menu from '../UI/Menu/Menu'
import MenuButton from '../UI/Menu/MenuButton'
import MenuItem from '../UI/Menu/MenuItem'

const MyMenu: FC = () => {
    const stations = useAppSelector(stationSelectors.stations)
    const currentStation = useAppSelector(stationSelectors.currentStation)

    const dispatch = useAppDispatch()

    const [open, setOpen] = useState(false)

    const handlePress = useCallback(() => {
        performHaptics()

        setOpen(true)
    }, [])

    const handleDismiss = () => {
        setOpen(false)
    }

    const handleItemPress = (station: IStation) => {
        performHaptics()

        dispatch(setCurrentStation(station))
        dispatch(setIsArchive(false))

        setOpen(false)
    }

    return (
        <Menu
            title={currentStation?.name ?? ''}
            open={open}
            progressAnimating={!isDetox}
            onPress={handlePress}
            onDismiss={handleDismiss}
            Button={MenuButton}
        >
            {stations
                ?.filter(({ code }) => code !== currentStation!.code)
                .map((station) => (
                    <MenuItem key={station.id} onPress={() => handleItemPress(station)}>
                        {station.name}
                    </MenuItem>
                ))}
        </Menu>
    )
}

export default MyMenu
